import { matchPath, useLocation } from 'react-router-dom';
import { APP_ROUTES } from 'src/constants';

export const useInterviewBookingNavigationSteps = () => {
  const location = useLocation();

  const isInterviewBookingStepper = !!matchPath(
    APP_ROUTES.INTERVIEW_BOOKING_SCHEDULE,
    location.pathname,
  );

  return {
    interviewBookingNavigationSteps: isInterviewBookingStepper
      ? [
          {
            label: 'Schedule a Technical Interview',
            numeration: 1,
            isActive: true,
            isCompleted: false,
            isNavigatable: false,
          },
        ]
      : null,
  };
};
